import React from 'react';
import { useTranslation } from 'react-i18next';

const Error404 = () => {
  const { t } = useTranslation();
  return <div>{t('error.404')}</div>;
};

Error404.propTypes = {};

export default Error404;
